import FieldContent from "./FieldContent/FieldContent"
import classes from './Field.module.scss'

const Field = () => {

    return (
        <div className={classes.projectsContainer}>
                <FieldContent/>
        </div>
    )
}

export default Field